/**
 * @module  Income Free
 */
import {getField, updateField} from 'vuex-map-fields';
import {mixin} from "../../helpers/helper";

export default {
    mixins: [mixin],
    namespaced: true,
    state: {
        inputs_1: [],
        inputs_2: [],
        inputs_3: [],
        showModalConfigure: false,
        formData: [],
        id: 0,
        type: 0,
        customId: 0,
        mappedBuilding: [],
        saveOk: false,
        showHideModalRating: false,
        personalInvestment: [],
        rating: {
            storeModule: 'customfree',
            questionRate: '<strong>Valuta</strong> la gestione del Conto Economico',
            section: 'Conto Economico Mercato Libero',
            showHideModalRating: false,
        }

    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        saveOkSet: function (state, boolean) {
            state.saveOk = boolean;
        },
        initPropsSet: function (state, data) {
            state.id = data.id;
            state.type = data.type;
            state.customId = data.customId;
        },
        buildingDetailSet: function (state, data) {
            state.mappedBuilding = data;
        },
        showModalConfigureSet: function (state) {
            state.showModalConfigure = !state.showModalConfigure;
        },

        customFreeSet: function (state, data) {
            state.formData.percentage_estate_1 = data.customData.percentuale_agenzia_1;

            state.formData.percentage_estate_2 = data.customData.percentuale_agenzia_2;
            state.formData.percentage_estate_3 = data.customData.percentuale_agenzia_3;
            state.formData.substitutiveTax_1 = data.customData.percentuale_imposta_sostitutiva_1;
            state.formData.substitutiveTax_2 = data.customData.percentuale_imposta_sostitutiva_2;
            state.formData.substitutiveTax_3 = data.customData.percentuale_imposta_sostitutiva_3;
            state.formData.percentage_tax_1 = data.customData.percentuale_tassa_1;
            state.formData.percentage_tax_2 = data.customData.percentuale_tassa_2;
            state.formData.percentage_tax_3 = data.customData.percentuale_tassa_3;
            state.formData.costi_4 = data.customData.costi_4;
            state.formData.costi_4_totale_finanziamento = data.customData.costi_4_totale_finanziamento;
            state.formData.costi_4_totale = data.customData.costi_4_totale;
            state.formData.costi_4_mq = data.customData.costi_4_mq;
            state.formData.costi_4_mq_tasse = data.customData.costi_4_mq_tasse;
            state.formData.ricavi_4_mq = data.customData.ricavi_4_mq;
            state.formData.utile_4_lordo = data.customData.utile_4_lordo;
            state.formData.totale_4_tasse = data.customData.totale_4_tasse;
            state.formData.utile_4_netto = data.customData.utile_4_netto;
            state.personalInvestment.scenario_1 = data.customData.capitale_proprio;
            state.personalInvestment.scenario_2 = data.customData.capitale_proprio_2;
            state.personalInvestment.scenario_3 = data.customData.capitale_proprio_3;
            state.personalInvestment.scenario_4 = data.customData.capitale_proprio_4;


            state.inputs_1 = data.customFieldList.filter(function (item) {
                return item.blocco === 1;
            });
            state.inputs_2 = data.customFieldList.filter(function (item) {
                return item.blocco === 2;
            });
            state.inputs_3 = data.customFieldList.filter(function (item) {
                return item.blocco === 3;
            });
        },

        defaultCustomFreeSet: function (state) {
            state.formData.percentage_estate_1 = "3.0";
            state.formData.percentage_estate_2 = "3.0";
            state.formData.percentage_estate_3 = "3.0";
            state.formData.substitutiveTax_1 = "0.2";
            state.formData.substitutiveTax_2 = "0.2";
            state.formData.substitutiveTax_3 = "0.2";
            state.formData.percentage_tax_1 = "20.0";
            state.formData.percentage_tax_2 = "20.0";
            state.formData.percentage_tax_3 = "20.0";

            state.inputs_1 = [];
            state.inputs_2 = [];
            state.inputs_3 = [];

            // ref: the field is blocked and edited. We use it to generate further amount
            // codice: the field is blocked and readonly. we use it to create a manual row with automatism (ex. 100 * 0.25)

            state.inputs_1.push(
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Costo di ristrutturazione',
                    blocco: 1,
                    opzionale: 0,
                    ref: 1,
                    codice: ''
                },
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Curatore giudiziale',
                    blocco: 1,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Agenzia Vendita',
                    blocco: 1,
                    opzionale: 0,
                    ref: 0,
                    codice: 'agenzia'
                },
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'HomeStaging',
                    blocco: 1,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },

                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Studio Architetto',
                    blocco: 1,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },

                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Tari + Tasi',
                    blocco: 1,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },


                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Spese Condominiali 2 anni',
                    blocco: 1,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Nuove utenze luce/gas',
                    blocco: 1,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },

                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Tassazioni imp. registro',
                    blocco: 1,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Imprevisti',
                    blocco: 1,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },
            );

            state.inputs_2.push(
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Mutuo Erogato',
                    blocco: 2,
                    opzionale: 0,
                    ref: 1,
                    codice: ''
                },
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Notaio ipoteca',
                    blocco: 2,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },

                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Manager',
                    blocco: 2,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },

                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Perito',
                    blocco: 2,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Spese istruttoria',
                    blocco: 2,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Imposta sostitutiva',
                    blocco: 2,
                    opzionale: 0,
                    ref: 0,
                    codice: 'impostaSostitutiva'
                },
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Assicurazione',
                    blocco: 2,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Interessi mesi',
                    blocco: 2,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },

                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Rimborso capitale',
                    blocco: 2,
                    opzionale: 1,
                    ref: 0,
                    codice: ''
                },
            );

            state.inputs_3.push(
                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Totale Ricavi',
                    blocco: 3,
                    opzionale: 0,
                    ref: 2,
                    codice: ''
                },

                {
                    importo_1: 0,
                    importo_2: 0,
                    importo_3: 0,
                    importo_4: 0,
                    etichetta: 'Ricavi MQ',
                    blocco: 3,
                    opzionale: 0,
                    ref: 0,
                    codice: ''
                },
            );

        },
    },
    actions: {

        initCustomFree: function (state, data) {
            state.commit('initPropsSet', data);
            state.dispatch('retrieveCustomFreeData');
        },


        retrieveCustomFreeData: function (state) {


            if (state.state.customId != undefined) {
                axios.get('/api/v1/custom/retrieveCustomFreeDataAuction/' + state.state.customId)
                    .then(function (response) {
                        if (response.data.customFieldList.length === 0) {
                            state.commit('defaultCustomFreeSet');
                        } else {
                            state.commit('customFreeSet', response.data);
                        }
                    });
            }
        },

        sendData: function (state) {

            axios.post('/api/v1/custom/SendCustomFreeData', {
                customId: state.state.customId,
                customFields_1: state.state.inputs_1,
                customFields_2: state.state.inputs_2,
                customFields_3: state.state.inputs_3,
                percentage_estate_1: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_1),
                percentage_estate_2: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_2),
                percentage_estate_3: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_estate_3),
                substitutiveTax_1: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.substitutiveTax_1),
                substitutiveTax_2: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.substitutiveTax_2),
                substitutiveTax_3: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.substitutiveTax_3),
                percentage_tax_1: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_tax_1),
                percentage_tax_2: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_tax_2),
                percentage_tax_3: mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(state.state.formData.percentage_tax_3),
                costi_4: mixin.methods.REMOVE_DOT(state.state.formData.costi_4),
                costi_4_totale_finanziamento: mixin.methods.REMOVE_DOT(state.state.formData.costi_4_totale_finanziamento),
                costi_4_totale: mixin.methods.REMOVE_DOT(state.state.formData.costi_4_totale),
                costi_4_mq: mixin.methods.REMOVE_DOT(state.state.formData.costi_4_mq),
                costi_4_mq_tasse: mixin.methods.REMOVE_DOT(state.state.formData.costi_4_mq_tasse),
                ricavi_4_mq: mixin.methods.REMOVE_DOT(state.state.formData.ricavi_4_mq),
                utile_4_lordo: mixin.methods.REMOVE_DOT(state.state.formData.utile_4_lordo),
                totale_4_tasse: mixin.methods.REMOVE_DOT(state.state.formData.totale_4_tasse),
                utile_4_netto: mixin.methods.REMOVE_DOT(state.state.formData.utile_4_netto),
                capitale_proprio: mixin.methods.REMOVE_DOT(state.state.personalInvestment.scenario_1),
                capitale_proprio_2: mixin.methods.REMOVE_DOT(state.state.personalInvestment.scenario_2),
                capitale_proprio_3: mixin.methods.REMOVE_DOT(state.state.personalInvestment.scenario_3),
                capitale_proprio_4: mixin.methods.REMOVE_DOT(state.state.personalInvestment.scenario_4),
            })
                .then(function () {
                    //state.commit('showModalConfigureSet');
                    state.commit('saveOkSet', true);
                    state.dispatch('offMsg');

                })
                .catch(function (error) {

                });

        },

        /**
         * Used to show "saved" label everywhere
         * @param state
         */
        offMsg: function (state, data) {
            setTimeout(function () {
                state.commit('saveOkSet', false);
            }, 2000);
        },

        openCloseRatingModal: function (state) {

            axios.post('/api/v1/rating/checkRatingDone', {
                area: state.state.rating.section
            })
                .then(function (response) {
                    if (response.data === false) {
                        state.state.rating.showHideModalRating = !state.state.rating.showHideModalRating;
                    } else {
                        state.state.rating.showHideModalRating = false;
                    }


                })
                .catch(function (error) {

                })

        }

    }
}